/**
 * Formats a date as a relative time string using Intl.RelativeTimeFormat.
 *
 * @param {Date} date The date to format.
 * @param {string} locale The locale to use for formatting.
 *
 * @returns {string} The formatted relative time string (e.g., "today", "3 days ago", "2 weeks ago").
 */
export function formatRelativeTime( date, locale = "en" ) {
	const now = new Date();
	const diffMs = now.getTime() - date.getTime();
	const diffSeconds = Math.floor( diffMs / 1000 );
	const diffMinutes = Math.floor( diffSeconds / 60 );
	const diffHours = Math.floor( diffMinutes / 60 );
	const diffDays = Math.floor( diffHours / 24 );

	const rtf = new Intl.RelativeTimeFormat( locale, { numeric: "auto" } );

	if ( diffDays === 0 ) {
		// e.g. "today"
		return rtf.format( 0, "day" );
	}
	if ( diffDays < 7 ) {
		return rtf.format( -diffDays, "day" );
	}

	const diffWeeks = Math.floor( diffDays / 7 );
	if ( diffWeeks < 5 ) {
		return rtf.format( -diffWeeks, "week" );
	}

	const diffMonths = Math.floor( diffDays / 30 );
	if ( diffMonths < 12 ) {
		return rtf.format( -diffMonths, "month" );
	}

	const diffYears = Math.floor( diffDays / 365 );
	return rtf.format( -diffYears, "year" );
}
